import { useEffect } from "react";

/**
 * hook to trigger a function after user interacts with the page
 */
export function useOnFirstInteraction({
    onFirstInteraction,
}: {
    onFirstInteraction: (this: Document, ev: Event) => any;
}) {
    useEffect(() => {
        function addEventListeners() {
            document.addEventListener("scroll", onFirstInteraction);
            document.addEventListener("keydown", onFirstInteraction);
            document.addEventListener("click", onFirstInteraction);
            document.addEventListener("touchstart", onFirstInteraction);
        }

        function removeEventListeners() {
            document.removeEventListener("scroll", onFirstInteraction);
            document.removeEventListener("keydown", onFirstInteraction);
            document.removeEventListener("click", onFirstInteraction);
            document.removeEventListener("touchstart", onFirstInteraction);
        }

        addEventListeners();

        return () => {
            removeEventListeners();
        };
    }, []);
}
